<template>
  <img v-if="typeof data === 'string'" :src="data" class="img-default" />
  <img
    v-else-if="data?.iconUrl"
    :src="data?.iconUrl"
    :alt="data?.iconUrl"
    :width="data?.width"
    :height="data?.height"
  />
  <img v-else :src="data?.iconUrls[0]" :alt="data?.iconUrl" class="img-list" />
</template>

<script>
export default {
  name: 'TextPart',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
<style lang="scss" scoped>
.img-default {
  width: 12px;
  height: 12px;
  vertical-align: middle;
}
.img-list {
  height: 16px;
  border-radius: 2px;
  margin: 3px 8px 0px 0px;
}
</style>
